export default class Storage {

    constructor () {
        this.updateOnChange();
    }

    /**
     * Clear SessionStorage on NPM build storage.
     */
    updateOnChange () {
        // Return if no ImpactCity ajax_object.
        if ('undefined' === typeof gkt_ajax_object) {
            return;
        }

        if (gkt_ajax_object.storage.css !== this.get('css-id') || gkt_ajax_object.storage.js !== this.get('js-id')) {
            // Cleanup.
            this.clear();

            // Update Laravel Mix ID's.
            this.set('css-id', gkt_ajax_object.storage.css);
            this.set('js-id', gkt_ajax_object.storage.js);
        }
    }

    /**
     * Set sessionStorage value.
     * @param key {string}
     * @param value {string}
     */
    set (key, value) {
        if (undefined !== key && undefined !== value) {
            sessionStorage.setItem(`gkt_${key}`, value);
        }
    }

    /**
     * Get sessionStorage Value.
     *
     * @param key
     * @return {string|undefined}
     */
    get (key) {
        return sessionStorage.getItem(`gkt_${key}`) || undefined;
    }

    /**
     * Clears sessionStorage.
     */
    clear () {
        for (let [key] of Object.entries(sessionStorage)) {
            if( key.startsWith('gkt_') ) {
                sessionStorage.removeItem(key);
            }
        }

        if (!document.body.classList.contains('gk-backstop')) {
            console.info('GutenKit-Theme SessionStorage is cleared.');
        }
    }
}
